import { render, staticRenderFns } from "./DatasetTabUser.vue?vue&type=template&id=f612d968&scoped=true&lang=pug"
import script from "./DatasetTabUser.vue?vue&type=script&lang=js"
export * from "./DatasetTabUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f612d968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f612d968')) {
      api.createRecord('f612d968', component.options)
    } else {
      api.reload('f612d968', component.options)
    }
    module.hot.accept("./DatasetTabUser.vue?vue&type=template&id=f612d968&scoped=true&lang=pug", function () {
      api.rerender('f612d968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/DatasetTabUser.vue"
export default component.exports